module.exports = __webpack_public_path__ + "img/logogp1.00a04148.png";